import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SignalWifi0BarIcon(props: IconProps) {
    return <Icon {...props} iconKey={"signal_wifi_0_bar"}/>
}
